import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, Refresher } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "../../components/shared/Input/Button/ButtonsConstructor";
import { E_BoxRoute_Action, E_Route } from "../../models/constants/Enum_Routes";
import { E_RentWizard_Section } from "../../models/constants/Enums_RentWizard";
import { APP_CONSTANTS } from "../../models/constants/AppConstants";
import { locationThunk } from "../../store/store";
import withConfiguration from "../../components/shared/hoc/withConfiguration";
import Interpret from "../../components/shared/Localization/Interpret";
import { locationSelector } from "../../store/selectors/selectors";
import { LocationUtils } from "../../utils/LocationUtils";
import { Redirect, withLocalizationContext, withStoreConnection } from "../../components/components";
import { StorageUtils } from "../../utils/StorageUtils";
import withStorageUnit from "../../components/shared/hoc/withStorageUnit";
import { E_Configuration_DisplayMode } from "../../models/Models_Configuration";
import { E_DeliveryWizard_Section } from "../../models/constants/Enums_DeliveryWizard";

class ActivitySelect extends Component {
	componentDidMount() {
		this._locationRefresher = new Refresher(() => {
			const {configuration} = this.props;

			locationThunk.getLocation(configuration.locationID, true).finally(() => {
				this._locationRefresher.trigger();
			});
		}, APP_CONSTANTS.LOCATION_UPDATE_TIME);
	}

	componentWillUnmount() {
		this._locationRefresher.stop();
	}

	render({className, style, location, unit, localizationContext, configuration}) {
		const openingPeriods = LocationUtils.getOpeningPeriodsForToday(location) || {};
		const hourMinuteFormatter = new Intl.DateTimeFormat(localizationContext.getActiveLanguageISOCode(), {
			hour: "numeric",
			minute: "numeric",
		});
		const uniqueServiceTypes = StorageUtils.getServiceTypeForSelectionFromUnit(unit);
		const isSomeServiceAvailable = uniqueServiceTypes.length > 0;

		return (
			<section className={combineClasses("activity-select", className)} style={style}>
				{
					configuration.mode === E_Configuration_DisplayMode.DELIVERY &&
					!configuration.allowDelivery &&
					<Redirect to={E_Route.OPEN_BOX_PIN(E_BoxRoute_Action.RETRIEVE)}/>
				}

				<hr/>

				<div className={"dummy"}/>

				<nav className={"action-buttons"}>
					<ButtonsConstructor buttons={[
						configuration.mode !== E_Configuration_DisplayMode.DELIVERY &&
						{
							icon: "user-lock",
							text: (
								<div className={"button-content"}>
									<Interpret id={"box.rent"} className={"button-text"}/>

									{
										!isSomeServiceAvailable &&
										<b className={"occupied"}><Interpret id={"box.noneAvailable"}/></b>
									}
								</div>
							),
							href: E_Route.RENT_WIZARD(E_RentWizard_Section.TARIFF_SELECTION),
							disabled: !isSomeServiceAvailable,
						},
						{
							icon: "lock-open",
							text: "box.open",
							href: configuration.mode === E_Configuration_DisplayMode.DELIVERY ? E_Route.OPEN_BOX_PIN(E_BoxRoute_Action.RETRIEVE) : E_Route.OPEN_BOX,
						},
						configuration.allowDelivery &&
						{
							icon: "truck-loading",
							text: "box.deliverPackage",
							href: E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.PARTNER_SELECT),
						}
					]}/>
				</nav>

				<div className={"opening-hours"}>
					{
						!!openingPeriods.length &&
						<h2>
							<Interpret>
								{({findTerm}) => {
									return findTerm("location.openingHours").resolveVariables({
										periods: openingPeriods.map(period => {
											return findTerm("location.openingHours.period").resolveVariables({
												from: hourMinuteFormatter.format(period.fromDate),
												to: hourMinuteFormatter.format(period.toDate),
											}).toString();
										}).join(', ')
									}).toString();
								}}
							</Interpret>
						</h2>
					}
				</div>
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			//withConfiguration
			configuration: PropTypes.object,

			//withLocalizationContext
			localizationContext: PropTypes.object,

			//Store
			location: PropTypes.object,
		}
	}
}

const mapStateToProps = state => {
	return {
		location: locationSelector.selectData(state),
	};
};

export default withStoreConnection(mapStateToProps)(withStorageUnit(withConfiguration(withLocalizationContext(ActivitySelect))));
